import React from 'react';

import { Cart } from '@/types';

interface CartContext {
  cart: Opt<Cart>;
  setCart?: (value: Cart) => void;
}
export const CartContext = React.createContext<CartContext>({ cart: undefined });
